import { createRecipe } from './runtime.js';

const publicFocusRingInnerConfig = {"name":"publicFocusRingInner","className":"focus-ring-inner"}

export const publicFocusRingInner = /* @__PURE__ */ createRecipe(publicFocusRingInnerConfig)